import * as React from 'react';
import {lightGreen, orange, red, grey} from '@material-ui/core/colors';
import Grow from '@material-ui/core/Grow';
import {ThemeOptions} from '@material-ui/core/styles/createMuiTheme';
import {PaletteOptions} from '@material-ui/core/styles/createPalette';
import {createMuiTheme} from '@material-ui/core/styles';
import {TransitionProps} from '@material-ui/core/transitions';
import {ModalManager} from '@material-ui/core/Modal';

const theme = createMuiTheme({});
export default {
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiInputLabel: {
      root: {
        whiteSpace: 'nowrap',
      },
    },
    MuiInput: {
      formControl: {
        marginTop: theme.spacing(2), // MUI default makes the field different height with/without label
      },
    },
    MuiInputBase: {
      input: {
        textOverflow: 'ellipsis',
      },
    },
    MuiDialogTitle: {
      root: {
        textTransform: 'capitalize',
      },
    },
    MuiTableSortLabel: {
      root: {
        flexDirection: 'initial',
      },
    },
    MuiList: {
      root: {
        backgroundColor: 'inherit',
      },
    },
    MuiCheckbox: {
      indeterminate: {
        color: lightGreen[700],
      },
    },
    MuiMenuItem: {
      root: {
        height: 'auto',
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
      },
    },
    MuiTableCell: {
      root: {
        paddingRight: theme.spacing(2),
        paddingLeft: theme.spacing(2),
      },
    },
    MuiTooltip: {
      tooltip: {
        fontSize: theme.typography.pxToRem(12),
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    },
    MuiFormHelperText: {
      root: {
        marginTop: 0,
      },
    },
    MuiGrid: {
      'direction-xs-column': {
        flexWrap: 'nowrap',
      },
    },
    MuiButton: {
      root: {
        whiteSpace: 'nowrap',
      },
    },
    MuiButtonGroup: {
      grouped: {
        margin: 0,
      },
    },
    MuiDialogContent: {
      root: {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
    MuiFormControl: {
      root: {
        maxWidth: '100%',
      },
    },
  },
  palette: {
    primary: {main: lightGreen[700]},
    secondary: {main: orange[800], light: orange[50]},
    error: {main: red[700], light: red[50]},
    layout: {main: grey[800], dark: grey[900], light: grey[700]},
  },
  darkPalette: {
    secondary: {main: orange[500]},
  },
  props: {
    MuiFormControl: {margin: 'dense'},
    MuiDialog: {disableEnforceFocus: true, TransitionComponent: Grow as React.ComponentType<TransitionProps>},
    MuiPopover: {manager: new ModalManager({handleContainerOverflow: false})},
    MuiPaper: {square: true},
    MuiCheckbox: {color: 'primary'},
  },
} as ThemeOptions & {darkPalette?: PaletteOptions};
